import { Option } from "./Option";
import { OptionSchema } from "./OptionSchema";

export class List {
  _key?: string;
  id?: string;
  name: string;
  state: boolean;
  isCategory: boolean;
  isDocumentCategory: boolean;
  listType: string;
  options: Array<Option>;
  optionsSchema: Array<OptionSchema>;
  dateCreated: number;
  dateChanged?: number;
  changedBy?: string;
  createdBy: string;
  dateVoided?: number;
  color?: string;

  constructor(
    name: string,
    state: boolean,
    options: Array<Option>,
    optionsSchema: Array<OptionSchema>,
    isCategory?: boolean,
    isDocumentCategory?: boolean,
    color?: string,
    listType?: string
  ) {
    this.name = name;
    this.state = state;
    this.isCategory = isCategory ?? false;
    this.isDocumentCategory = isDocumentCategory ?? false;
    this.options = options;
    this.optionsSchema = optionsSchema;
    this.dateCreated = Date.now();
    this.createdBy = "";
    this.color = color ?? "";
    this.listType = listType ?? "";
  }
}
